import { GridState } from '@medpacesoftwaredevelopment/designsystem/lib/components/ag-grid';
import { LocalStorageAgGridState } from '../../models/local-storage/local-storage-state.model';

/**
 * Util class to handle saving / getting and deleting ag-grid state and prefilters in local storage
 */
export class LocalStorageAgGridHandler {
    public static saveToLocalStorage<T>(localStorageName: string, gridState: GridState, prefilter?: T): void {
        // create object
        const state: LocalStorageAgGridState<T> = {
            prefilter: prefilter,
            state: gridState,
        };

        const stateString = JSON.stringify(state);

        localStorage.setItem(localStorageName, stateString);
    }

    public static getFromLocalStorage<T>(localStorageName: string): LocalStorageAgGridState<T> | null {
        const stringValue = localStorage.getItem(localStorageName);

        if (!stringValue) return null;

        const state: LocalStorageAgGridState<T> = JSON.parse(stringValue);

        return state;
    }

    public static deleteFromLocalStorage(localStorageName: string) {
        localStorage.removeItem(localStorageName);
    }
}
